export const DemandbaseAudiences = Object.freeze([
  {
    label: 'Enterprise Business',
    value: 'Enterprise Business'
  },
  {
    label: 'Mid-Market Business',
    value: 'Mid-Market Business'
  },
  {
    label: 'SMB',
    value: 'SMB'
  },
  {
    label: 'Government',
    value: 'Government'
  },
  {
    label: 'Education',
    value: 'Education'
  },
  {
    label: 'Hospitality',
    value: 'Hospitality'
  },
  {
    label: 'Residential',
    value: 'Residential'
  },
  {
    label: 'Wireless',
    value: 'Wireless'
  },
  {
    label: 'Bot',
    value: 'Bot'
  },
  {
    label: 'SOHO',
    value: 'SOHO'
  },
  {
    label: 'Obscured',
    value: 'Obscured'
  },
])


// WEBPACK FOOTER //
// ./src/scripts/constants/DemandbaseAudiences.js